import React from "react";
import { Result, Button } from 'antd';
import { SmileOutlined } from '@ant-design/icons';

export default function UnderConstruction() {
  return (
    <Result
    icon={<SmileOutlined />}
    title="This Page is temporarily down for maintenance"
    subTitle="We're working hard to bring this feature to you. Stay tuned!"
    extra={<Button type="primary" onClick={() => window.location.href = "/login"}>Go Back</Button>}
  />
  );
}